
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetohyderabadcabs() {



    const cardData =
    {
        keyword: 'Pune to Hyderabad Cab ',
        heading: 'Platinum24 Cabs: Pune to Hyderabad Cab',
        headingDescription: ' Platinum24 Cabs provides dependable Pune to Hyderabad cab services, ideal for business trips, family visits, and leisure travel. Whether you’re traveling to Hyderabad for IT work in Hitech City, visiting Charminar and Golconda Fort, or attending events and family functions, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable and secure ride. With professional chauffeurs, punctual pickups, and clear pricing, we make your intercity journey hassle-free. From airport transfers to one-way or round trips, Platinum24 Cabs guarantees safe, reliable, and enjoyable Pune to Hyderabad travel.',

        top: 'Top Places to Visit in Hyderabad with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar, built in 1591 by Sultan Mohammed Quli Qutb Shah, is Hyderabad’s most iconic landmark. The monument with four grand minarets stands in the heart of the old city. Surrounding bazaars sell pearls, bangles, and spices. Evening lighting makes it magical for photography. Tourists climb inside for panoramic city views. Charminar is Hyderabad’s symbol of heritage and pride."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort, once the capital of medieval Golconda Sultanate, is a marvel of architecture and acoustics. Its unique design allows sound from the Fateh Darwaza to be heard at the highest point. The fort also houses royal palaces, temples, and mosques. The evening light-and-sound show narrates its history vividly. From the top, visitors enjoy city views. Golconda Fort is Hyderabad’s historic crown."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar, built in 1563, is a vast artificial lake linking Hyderabad and Secunderabad. Its highlight is the giant Buddha statue standing on Gibraltar Rock in the middle of the lake. Boating, sailing, and laser shows attract tourists. Necklace Road and Tank Bund around the lake are popular hangout spots. Sunsets here are spectacular. Hussain Sagar is Hyderabad’s scenic heart."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City, spread over 2,000 acres, is the world’s largest film studio complex. It offers guided tours of movie sets, gardens, and theme parks. Adventure zones, cultural shows, and live performances entertain visitors. Families love its amusement rides and dining options. It is a must-visit for cinema lovers. Ramoji Film City is Hyderabad’s reel-world wonder."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum, one of India’s largest museums, houses a vast collection of art, antiques, and artifacts. Its exhibits include European paintings, Persian carpets, Mughal miniatures, and Japanese sculptures. The Veiled Rebecca and Musical Clock are iconic attractions. History and art enthusiasts find it enriching. The museum preserves treasures from around the world. Salar Jung is Hyderabad’s cultural heritage hub."
  },
  {
    "title": "Mecca Masjid",
    "description": "Mecca Masjid, built in the 17th century, is one of India’s largest mosques located near Charminar. Bricks used in its central arch were made from soil brought from Mecca. The mosque can accommodate over 10,000 worshippers at a time. Its massive pillars and arches showcase Qutb Shahi architecture. The serene atmosphere draws devotees and visitors alike. Mecca Masjid is Hyderabad’s spiritual landmark."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace, once the seat of the Nizams, reflects Persian and Indo-Saracenic architecture. Its grand halls, chandeliers, and courtyards showcase royal opulence. The Khilwat Mubarak hall with its Belgian chandeliers is breathtaking. The palace also houses vintage cars and royal artifacts. Cultural events are often held here. Chowmahalla is Hyderabad’s royal heritage palace."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir, built of pure white marble, is dedicated to Lord Venkateswara. Situated on Naubat Pahad hill, it offers panoramic views of Hyderabad. The temple combines Dravidian, Rajasthani, and Utkal styles of architecture. Its peaceful ambiance attracts devotees and tourists alike. At night, the illuminated temple looks divine. Birla Mandir is Hyderabad’s spiritual jewel."
  },
  {
    "title": "Laad Bazaar",
    "description": "Laad Bazaar, located near Charminar, is Hyderabad’s most famous shopping street. It is renowned for lacquer bangles, pearls, and bridal jewelry. The colorful shops and buzzing lanes attract locals and tourists. Shoppers also find textiles, perfumes, and handicrafts here. Bargaining adds fun to the experience. Laad Bazaar is Hyderabad’s vibrant cultural marketplace."
  },
  {
    "title": "Hyderabadi Cuisine & Biryani",
    "description": "No trip to Hyderabad is complete without savoring Hyderabadi Biryani, a royal dish infused with spices and flavors. Iconic outlets like Paradise and Bawarchi serve authentic biryanis. The city is also famous for haleem, kebabs, and Irani chai. Food lovers explore local eateries in old Hyderabad for a culinary feast. Festivals add more flavors to the cuisine. Hyderabadi food is the city’s cultural heartbeat."
  }
],


        "services": [
    {
      "name": "Pune to Hyderabad Cab",
      "description": "Travel conveniently with our Pune to Hyderabad Cab service, offering reliable intercity transportation with professional drivers and well-maintained vehicles. Whether for business, family trips, or casual travel, our cabs ensure a safe and pleasant ride across states."
    },
    {
      "name": "Book Pune to Hyderabad Taxi",
      "description": "Book your Pune to Hyderabad Taxi with ease through our intuitive online platform. Choose from multiple car options, get real-time fare estimates, and receive instant booking confirmation for a smooth and worry-free travel experience."
    },
    {
      "name": "Pune to Hyderabad Car Hire",
      "description": "Our Pune to Hyderabad Car Hire service offers flexible rental solutions for your journey. Choose from self-drive or chauffeur-driven cars across a wide range of models, including sedans, hatchbacks, and SUVs, all available at competitive rates."
    },
    {
      "name": "Pune to Hyderabad Taxi Service",
      "description": "Experience dependable long-distance travel with our Pune to Hyderabad Taxi Service. Featuring skilled drivers, GPS-enabled vehicles, and 24/7 customer support, this service is ideal for anyone seeking comfort and reliability on their intercity trip."
    },
    {
      "name": "Pune to Hyderabad One Way Cab",
      "description": "Save money and enjoy convenience with our Pune to Hyderabad One Way Cab service. Pay only for the distance you travel with no return fare, making it perfect for single-trip travelers, business commuters, and students relocating."
    },
    {
      "name": "Affordable Pune to Hyderabad Cabs",
      "description": "Get the best value with our Affordable Pune to Hyderabad Cabs. Designed to offer comfort at budget-friendly prices, this service is ideal for regular travelers, students, and families looking for reliable and economical travel options."
    },
    {
      "name": "Pune to Hyderabad Outstation Cabs",
      "description": "Our Pune to Hyderabad Outstation Cabs are perfect for those planning a long journey across states. With spacious seating, experienced drivers, and on-time service, we ensure you travel comfortably and safely on your extended trips."
    },
    {
      "name": "Pune to Hyderabad Cab Booking",
      "description": "Book your Pune to Hyderabad cab in just a few clicks with our seamless cab booking service. Get access to various vehicle options, instant booking confirmation, and transparent pricing, all in one user-friendly platform."
    },
    {
      "name": "Pune to Hyderabad Taxi Fare",
      "description": "Check Pune to Hyderabad Taxi Fare instantly with our transparent fare calculator. Our all-inclusive pricing model ensures no hidden costs, so you can plan your journey confidently and stay within your travel budget."
    },
    {
      "name": "Cab from Pune to Hyderabad",
      "description": "Looking for a dependable Cab from Pune to Hyderabad? Our service offers comfort, punctuality, and safety at every step. Choose from a variety of vehicles and enjoy a smooth ride with courteous drivers and 24/7 customer assistance."
    },
    {
      "name": "Hyderabad to Pune Taxi",
      "description": "Book a return trip easily with our Hyderabad to Pune Taxi service. Whether for business or personal travel, we offer the same high-quality service with flexible scheduling, experienced drivers, and clean, comfortable vehicles."
    },
    {
      "name": "Pune to Hyderabad Cab Charges",
      "description": "Know your Pune to Hyderabad Cab Charges upfront with our fair and fixed pricing structure. We provide a complete fare breakdown at the time of booking, ensuring full transparency and no last-minute surprises."
    },
    {
      "name": "Pune to Hyderabad Drop Taxi",
      "description": "Opt for our Pune to Hyderabad Drop Taxi service for one-way drop-offs without paying for the return trip. This service is ideal for airport transfers, business meetings, or shifting to a new city, with flexible booking and affordable rates."
    },
    {
      "name": "Pune to Hyderabad Car Rental",
      "description": "Explore convenient travel with our Pune to Hyderabad Car Rental service. Whether you're planning a family trip or a solo drive, our car rental options offer flexibility, comfort, and a range of models to choose from, all at great rates."
    }
  ],
  "tableData": [
    ["Pune to Hyderabad Cab", "Book Pune to Hyderabad Taxi"],
    ["Pune to Hyderabad Car Hire", "Pune to Hyderabad Taxi Service"],
    ["Pune to Hyderabad One Way Cab", "Affordable Pune to Hyderabad Cabs"],
    ["Pune to Hyderabad Outstation Cabs", "Pune to Hyderabad Cab Booking"],
    ["Pune to Hyderabad Taxi Fare", "Cab from Pune to Hyderabad"],
    ["Hyderabad to Pune Taxi", "Pune to Hyderabad Cab Charges"],
    ["Pune to Hyderabad Drop Taxi", "Pune to Hyderabad Car Rental"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Hyderabad Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs offers comfortable and dependable cab services from Pune to Hyderabad for a stress-free travel experience."
  },
  {
    "WhyChooseheading": "Multiple Vehicle Options for Your Travel Needs",
    "WhyChoosedescription": "Select from a wide range of well-maintained sedans, SUVs, and tempo travellers for your Pune to Hyderabad journey."
  },
  {
    "WhyChooseheading": "Sanitized and Hygienic Cabs for Safe Travel",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every ride to ensure your safety and comfort."
  },
  {
    "WhyChooseheading": "Professional Drivers with Route Expertise",
    "WhyChoosedescription": "Our experienced drivers are well-acquainted with Pune to Hyderabad routes, ensuring timely and smooth travel."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Enjoy affordable fares with no hidden charges—fuel, tolls, and driver allowance are all included in the package."
  },
  {
    "WhyChooseheading": "Round-the-Clock Customer Support",
    "WhyChoosedescription": "Get 24/7 assistance for bookings, queries, or support related to your Pune to Hyderabad cab trip."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans to Suit Your Schedule",
    "WhyChoosedescription": "Choose from one-way, round-trip, or custom rental packages based on your travel preferences."
  },
  {
    "WhyChooseheading": "Instant Online Booking and Confirmation",
    "WhyChoosedescription": "Easily book your Pune to Hyderabad cab through our website or app with immediate confirmation and secure payment options."
  }
]


















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Hyderabad cab service?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services from Pune to Hyderabad with professional drivers and clean vehicles.',
    },
    {
        question: 'How can I book a cab from Pune to Hyderabad?',
        answer: 'Booking is simple via our website, mobile app, or by calling our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Hyderabad travel?',
        answer: 'We offer hatchbacks, sedans, SUVs, and luxury vehicles to match your comfort and budget for the Pune to Hyderabad route.',
    },
    {
        question: 'Is one-way cab service available from Pune to Hyderabad?',
        answer: 'Yes, you can book both one-way and round-trip cab services for Pune to Hyderabad with Platinum24 Cabs.',
    },
    {
        question: 'Are drivers experienced for Pune to Hyderabad intercity trips?',
        answer: 'Yes, our drivers are licensed, trained, and experienced with long-distance routes like Pune to Hyderabad.',
    },
    {
        question: 'Can I choose custom pickup and drop locations in Pune and Hyderabad?',
        answer: 'Absolutely, you can specify your exact pickup and drop-off points in both Pune and Hyderabad.',
    },
    {
        question: 'What safety protocols are followed for Pune to Hyderabad cabs?',
        answer: 'All our cabs are sanitized regularly, and our drivers follow proper safety and hygiene protocols throughout the journey.',
    },
    {
        question: 'Is Pune to Hyderabad cab service available 24x7?',
        answer: 'Yes, our Pune to Hyderabad cab service operates round the clock to suit your travel needs.',
    },
    {
        question: 'What are the payment options for Pune to Hyderabad cab bookings?',
        answer: 'We accept payments via UPI, wallets, credit/debit cards, and cash for a seamless experience.',
    },
    {
        question: 'Are there customizable packages for Pune to Hyderabad cab travel?',
        answer: 'Yes, we provide flexible packages that can be customized based on your trip duration, stops, and preferences.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Suresh Reddy',
        feedback: 'Excellent service on my Pune to Hyderabad trip. The car was clean, and the driver was very professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha Kulkarni',
        feedback: 'Platinum24 Cabs made my Pune to Hyderabad journey hassle-free and comfortable. Great value for money!',
        rating: 5,
    },
];






































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneToHyderabadCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Hyderabad Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-hyderabad-cab.jpg",
  "description": "Book Pune to Hyderabad cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and outstation taxi options for one-way and round trips. Reliable, comfortable, and available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-hyderabad-cab-service"
  }
};



    return (
        <div>


<Helmet>
  <title>Pune to Hyderabad Cab Service | Affordable Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Hyderabad cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and outstation taxi options for one-way and round trips. Reliable, comfortable, and available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Hyderabad Cab, Book Pune to Hyderabad Taxi, Pune to Hyderabad Car Hire, Pune to Hyderabad Taxi Service, Pune to Hyderabad One Way Cab, Affordable Pune to Hyderabad Cabs, Pune to Hyderabad Outstation Cabs, Pune to Hyderabad Cab Booking, Pune to Hyderabad Taxi Fare, Cab from Pune to Hyderabad, Hyderabad to Pune Taxi, Pune to Hyderabad Cab Charges, Pune to Hyderabad Drop Taxi, Pune to Hyderabad Car Rental"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToHyderabadCabSchema)}
  </script>
</Helmet>



            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/99.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetohyderabadcabs;